import { compact, parameterize, titleize } from '@moda/portal-stanchions';
import { TrunkshowListingPageFragment } from '../../generated/types';

export const createTrunkshowCategoryTree = (queryResult: TrunkshowListingPageFragment) => {
  const children = compact(
    queryResult.categories?.map(
      category =>
        category && {
          __typename: 'CategoryTree' as const,
          name: titleize(category.name),
          slug: parameterize(category.slug || ''),
          totalItems: category.totalItems ?? 0,
          children: null
        }
    )
  );

  const totalItems = queryResult.trunkshows.edges.length;

  return {
    __typename: 'CategoryTree' as const,
    name: '',
    slug: '',
    totalItems,
    children: [
      {
        __typename: 'CategoryTree' as const,
        name: '',
        slug: '',
        totalItems,
        children
      }
    ]
  };
};
